import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark text-white/40 text-center py-9 px-5 text-[0.78rem]" data-id="element-62">
      <div className="mb-3 flex justify-center gap-5 flex-wrap" data-id="element-63">
        <a href="#" className="hover:text-gold transition-colors" data-id="element-64">
          Aviso legal
        </a>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-65">
          Política de privacidad
        </a>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-66">
          Cookies
        </a>
        <a href="mailto:soporte@cherubagency.com" className="hover:text-gold transition-colors" data-id="element-67">
          soporte@cherubagency.com
        </a>
      </div>
      <p className="mb-2 max-w-[640px] mx-auto" data-id="element-68">
        Este producto es material educativo e informativo. No sustituye la
        orientación de un profesional de la salud. Ante cualquier duda sobre la
        salud de tu bebé, consulta siempre con tu pediatra.
      </p>
      <p data-id="element-69">© Cherub Agency™ 2026 · Todos los derechos reservados</p>
    </footer>;
}